import { render, staticRenderFns } from "./problemDialog.vue?vue&type=template&id=36f68a0e"
import script from "./problemDialog.vue?vue&type=script&lang=js"
export * from "./problemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports